var exports = {
  "p$": "DMChannelView.module__emptyState___ZkFkRU",
  "AI": "DMChannelView.module__emptyStateIcon___ZkFkRU",
  "vo": "DMChannelView.module__emptyStateTitle___ZkFkRU",
  "Li": "DMChannelView.module__emptyStateDescription___ZkFkRU",
  "fX": "DMChannelView.module__callParticipantsRow___ZkFkRU",
  "gN": "DMChannelView.module__compactCallParticipantsRow___ZkFkRU",
  "Gr": "DMChannelView.module__callParticipant___ZkFkRU",
  "Gj": "DMChannelView.module__callParticipantAvatar___ZkFkRU",
  "I9": "DMChannelView.module__callParticipantRinging___ZkFkRU",
  "rV": "DMChannelView.module__call-participant-ring-pulse___ZkFkRU",
  "Jn": "DMChannelView.module__callBanner___ZkFkRU",
  "nY": "DMChannelView.module__callBannerBody___ZkFkRU",
  "c7": "DMChannelView.module__callBannerResizable___ZkFkRU",
  "oo": "DMChannelView.module__callControlBarSection___ZkFkRU",
  "Pf": "DMChannelView.module__callControlBarInner___ZkFkRU",
  "tX": "DMChannelView.module__callControls___ZkFkRU",
  "pm": "DMChannelView.module__callBannerMobile___ZkFkRU",
  "h8": "DMChannelView.module__callBannerMobileLabel___ZkFkRU",
  "ZI": "DMChannelView.module__callControlsMobile___ZkFkRU",
  "IX": "DMChannelView.module__compactCallResizeHandle___ZkFkRU",
  "rF": "DMChannelView.module__compactCallResizePill___ZkFkRU",
};

module.exports = exports;
